<template>
    <div class="page">
        <transition name="fade">
            <ul class="text" ref="ul" v-if="textShow">
                <li ref="li">雪</li>
                <li ref="li">景</li>
                <li ref="li">寒</li>
                <li ref="li">林</li>
                <li ref="li" @animationend="animationend">图</li>
            </ul>
        </transition>
        <div class="play" v-if="show" @click="next"></div>
        <div class="snow">
            <div class="s1"></div>
            <div class="s2"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            textShow: true,
            show: false,
            timer: null
        };
    },
    methods: {
        next() {
            clearTimeout(this.timer);
            this.$emit('next', 1);
        },
        animationend() {
            this.timer = setTimeout(() => {
                this.textShow = false;
                this.timer = setTimeout(() => {
                    this.textShow = true;
                }, 800);
            }, 5000);
        }
    },
    created() {
        setTimeout(() => {
            this.show = true;
        }, 4000);
    }
};
</script>

<style lang="stylus" scoped>
.page
    z-index 1
.snow
    position absolute
    top 0
    left 0
    size 100%
    .s1
        position absolute
        top 0
        left 0
        transform translate3d(0, -100%, 1px)
        size 100%
        background: url('/img/xj/xue.png') 0 0/auto 100% no-repeat,
                    url('/img/xj/xue.png') 0 0/auto 100% no-repeat
        background-size auto 100%
        animation snowA 30s infinite linear
    .s2
        position absolute
        top 0
        left 0
        transform translate3d(0, -100%, 1px)
        size 100%
        background url('/img/xj/xue.png') no-repeat
        background: url('/img/xj/xue.png') 0 0/auto 100% no-repeat,
                    url('/img/xj/xue.png') 0 0/auto 100% no-repeat
        background-size auto 100%
        animation snowA 30s infinite linear
        animation-delay 15s
.text
    position absolute
    top .9rem
    right .7rem
    li
        font-size .72rem
        color #fff
        line-height .8rem
        overflow hidden
        opacity 0
        animation show .8s cubic-bezier(0.55, 0.085, 0.68, 0.53)
        animation-fill-mode forwards
        for i in 1 2 3 4 5
            &:nth-child({i})
                animation-delay i s
.play
    position absolute
    size 2.5rem 1.46rem
    z-index 1
    bottom .02rem
    left 50%
    transform translatex(-50%)
    background url('/img/xj/btn_play.gif') 0 0/100% 100% no-repeat
</style>
